import mietendeckel from '../../fields/cases/mietendeckel';

export const QUERY_GET_MD_CASE = /* GraphQL */ `
	query($id: String!) {
		getMietendeckelCase(id: $id) {
			${mietendeckel}
		}
	}
`;
